import React, { useEffect, useState } from "react";
import "../../Dashboard/Dashboard.css";
import "../../Dashboard/Sidebar.js";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import Regex from "../../../service/Regex";
import loader from "../../../Loader/Loader";
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
import DashboardMenu from "../../layout/dashboardMenu";
import Loader from "../../../Loader/Loader";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";

const CreateLeads =  ({
                          history = null,
                          saveLead,
                          lead=[],
                          getLeadById,
                          leadById=[],
                          match
}) => {
    const islatlng = useLatLng();
    const [inputData , SetInputData] = useState([{name:"",contact:"",email:"",account_name:"", lat:"",
        long:"", type:''}]);
    const [isLoading, setIsLoading] = useState(false)
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [userMessage, setUserMessage] = useState('')
    const [redirectUrl, setRedirectUrl] = useState('')
    const [isAllow, setIsAllow] = useState(false);
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });

    useEffect(() => {
        if(match?.params.id !== undefined){
            (async () => {
                setIsLoading(true)
                await getLeadById(match?.params.id)
                setIsLoading(false)
            })()
        }
    }, [])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        if(leadById && leadById?.data !== undefined){
            let list = [...inputData]
            list[0]['name'] = leadById?.data?.poc_name
            list[0]['email'] = leadById?.data?.email
            list[0]['contact'] = leadById?.data?.number
            list[0]['account_name'] = leadById?.data?.account_name
            SetInputData(list)
        }
    }, [leadById])


    const handleInputValue = (val, key) => {
        const list = [...inputData];
        list[0][key] = val;
        SetInputData(list);
    };

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (parseInt(lead?.status) === 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsSuccessModalOpen(true)
            setUserMessage(lead?.message)
        } else if (lead?.status !== undefined && lead?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setUserMessage(lead?.message)
        }
    }, [lead])
    

    // const successCallback = (position) => {
    //     console.log(position);
    // };
      
    // const errorCallback = (error) => {
    //     console.log(error);
    //     toast.error('Please enable your location');
    // };

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = [...inputData]
        list[0]['lat'] = islatlng?.lat
        list[0]['long'] = islatlng?.lng
        if(list[0]['long'] == null || list[0]['lat'] == null){
            toast.error('Please enable your location');
            //navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
            return false
        }
        list[0]['type'] = 'lsq'
        if(match?.params?.id !== undefined){
            list[0]['id'] = match?.params.id
        }
        setIsLoading(true)
        await saveLead(list[0])
        setIsLoading(false)
        setRedirectUrl('lead-list/')
    }

    return(
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={userMessage}
                url={redirectUrl}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={userMessage}
                countToOpenModal={countToOpenModal}
            />

            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={match?.params?.id !== undefined ? "Edit Lead" : "Add Lead"}
                        />


                        {/*BODY*/}

                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className="d-sm-flex align-items-center justify-content-between">
                                <h1 className="h3 mb-0 text-black-100 hide">Add Lead</h1>
                            </div>

                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="div-com-header">
                                            </div>
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-md-6 float-field ">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInputValue(e.target.value, 'name')
                                                                   }}
                                                                   required
                                                                   value={inputData[0]?.name}

                                                            />

                                                            <label className="large-label float-lb">
                                                                Poc Name <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input type="email"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInputValue(e.target.value, 'email')
                                                                   }}
                                                                   required
                                                                   value={inputData[0]?.email}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Email <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input type="number"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInputValue(e.target.value, 'contact')
                                                                   }}
                                                                   required
                                                                   value={inputData[0]?.contact}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Contact Number <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInputValue(e.target.value, 'account_name')
                                                                   }}
                                                                   required
                                                                   value={inputData[0]?.account_name}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Account Name <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-4">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        {match?.params?.id !== undefined ? 'Update' : 'Submit'}
                                    </button>
                                </div>
                            </form>
                            <img src="../img/leads.gif" width="90%"/>
                        </div>
                    </div>
                </div>

                <BottomMenu/>
            </div>
            {/* section ends */}
        </>
    )
}
export default CreateLeads